
export default {
  props: ["path", "src", "name", "createTime", "content"],
};
